import { ZarzDzaniePaczkamiService, ZarzDzanieSkrytkamiService } from '@coig/apm-api';
import { PackageManagementMockService } from './mocks/packageManagementService';
import { LockerManagementMockService } from './mocks/lockerManagementService';

let packageManagementService = ZarzDzaniePaczkamiService;
let lockerManagmentService = ZarzDzanieSkrytkamiService;
if (process.env.NODE_ENV) {
  packageManagementService = PackageManagementMockService;
  lockerManagmentService = LockerManagementMockService;
}

export { packageManagementService, lockerManagmentService };
